import { Col, Row } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';

import Img from 'gatsby-image';
import ReactMarkdown from 'react-markdown';
import SEO from '../../components/seo';
import SidePhoto from '../../components/SidePhoto';
import TrailTitle from '../../components/TrailTitle';
import { graphql } from 'gatsby';

const PartnersPage = ({ data, location }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen((o) => !o);

    return () => {
      setOpen((o) => !o);
    };
  }, []);

  return (
    <>
      <SEO title='Rekan' pathname='/about/partners' />
      <Img fluid={data.partner.cover.value.childImageSharp.fluid} />
      <Row
        css={{
          minHeight: '75vh',
          backgroundImage: `url(${data.bg.childImageSharp.fixed.src})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'top right',
        }}
        className='pt-5'>
        <Col
          sm={'5'}
          className='d-flex flex-column align-items-center align-content-center'
          css={{ justifyContent: 'space-between' }}>
          <TrailTitle open={open} className='pb-2 mb-5'>
            <div>Partner</div>
            <div>RSGM Bhakti Wiyata</div>
          </TrailTitle>
        </Col>
        <Col className='d-flex flex-column align-items-center align-content-center pl-3 pr-3 pt-1'>
          <ReactMarkdown
            source={data.partner.content.value}
            escapeHtml={false}
          />

          <Row css={{
            alignItems: 'stretch'
          }}>
            {data.partners.edges.map(({ node: { cockpitId, logo, name } }) =>
              <Col xs={4} className='d-flex align-items-center justify-content-center p-3' key={cockpitId} >
                <Img
                  className='d-block mx-auto img-fluid partner-logo'
                  fixed={logo.value.childImageSharp.fixed}
                  alt={'logo partner ' + name.value}
                  title={name.value}
                  css={{
                    overflow: 'visible !important',
                    '& img': {
                      transition: 'transform 0.3s cubic-bezier(.17,.67,.83,.67) !important',
                    },
                    '&:hover img': {
                      transform: 'translateY(-5px) scale(1.1)',
                    },
                  }}
                />
              </Col>
            )}
          </Row>
        </Col >
      </Row >
    </>
  );
};

export const query = graphql`
  {
    partner: cockpitPartner {
      content {
        type
        value
      }
      cover: cover_photo {
        type
        value {
          childImageSharp {
            fluid(maxWidth: 1920, toFormat: WEBP) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    }
    partners: allCockpitPartners(filter: { display: { value: { eq: true } } }) {
      edges {
        node {
          cockpitId
          name {
            value
          }
          description {
            type
            value
          }
          logo {
            type
            value {
              childImageSharp {
                fixed(toFormat: WEBP, width: 64) {
                  ...GatsbyImageSharpFixed_withWebp
                }
              }
            }
          }
        }
      }
    }
    bg: file(name: { eq: "bg-ring" }) {
      childImageSharp {
        fixed(toFormat: WEBP) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
  }
`;

export default PartnersPage;